import _regeneratorRuntime from "/www/wwwroot/kft.ycxxkj.com/admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/www/wwwroot/kft.ycxxkj.com/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/www/wwwroot/kft.ycxxkj.com/admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.keys.js";
import dayjs from 'dayjs';
import { mapActions } from 'vuex';
import localeMixin from '@/locales/mixin.js';
import verifyCode from '@/components/common/verifyCode';
import helper from '@/libs/helper.js';
import axios from '@/plugin/axios';
export default {
  mixins: [localeMixin],
  data: function data() {
    return {
      title: process.env.VUE_APP_TITLE,
      timeInterval: null,
      time: dayjs().format('HH:mm:ss'),
      // 快速选择用户
      dialogVisible: false,
      users: [],
      // 验证码初始值
      identifyCode: '1234',
      // 验证码的随机取值范围
      identifyCodes: '1234567890',
      // 表单
      formLogin: {
        username: '',
        password: '',
        code: ''
      },
      checkCode: '',
      // 表单校验
      rules: {
        username: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }]
      },
      data: {}
    };
  },
  components: {
    'v-code': verifyCode
  },
  mounted: function mounted() {
    var _this = this;
    this.identifyCode = '';
    // this.makeCode(this.identifyCodes, 4);
    this.changeCode();
    this.timeInterval = setInterval(function () {
      _this.refreshTime();
    }, 1000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timeInterval);
  },
  created: function created() {
    this.changeCode();
    this.refresh();
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/account', ['login'])), {}, {
    refresh: function refresh() {
      var page = this;
      page.axios.get("/admin/index/login").then(function (response) {
        response.data.offset = response.data.timestamp - parseInt(new Date().getTime() / 1000); //时间差
        page.data = response.data;
      });
    },
    refreshTime: function refreshTime() {
      this.time = dayjs().format('HH:mm:ss');
    },
    /**
     * @description 接收选择一个用户快速登录的事件
     * @param {Object} user 用户信息
     */
    handleUserBtnClick: function handleUserBtnClick(user) {
      this.formLogin.username = user.username;
      this.formLogin.password = user.password;
      this.submit();
    },
    /**
     * @description 提交表单
     */
    // 提交登录信息
    submit: function submit() {
      var _this2 = this;
      // console.log("this.formLogin.code = "+this.formLogin.code);
      // console.log("this.identifyCode = "+ this.identifyCode);
      var page = this;
      var vkey = localStorage.getItem("vKey");
      var vValue = localStorage.getItem("vValue");
      // console.log("this.vkey = "+vkey);
      // console.log("this.vValue = "+ vValue);
      var code = this.formLogin.code;
      var iCode = this.identifyCode;
      var c = code.toUpperCase();
      var ic = iCode.toUpperCase();
      // console.log("c " + c);
      // console.log("this.ic " + ic);
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          // 登录
          // 注意 这里的演示没有传验证码
          // 具体需要传递的数据请自行修改代码
          if (c != ic) {
            _this2.$message.error('验证码错误');
            _this2.changeCode();
          } else {
            _this2.login({
              username: _this2.formLogin.username,
              password: _this2.formLogin.password,
              vkey: vkey,
              vValue: vValue,
              timestamp: parseInt(new Date().getTime() / 1000) + page.data.offset
            }).then(function () {
              // 重定向对象不存在则返回顶层路径
              _this2.loadMenu();
              _this2.$router.replace(_this2.$route.query.redirect || '/');
            });
          }
        } else {
          // 登录表单校验失败
          _this2.changeCode();
          _this2.$message.error('表单校验失败，请检查');
          return;
        }
      });
      // console.log(this.formLogin.password);
    },
    loadMenu: function loadMenu() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, url, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              //加载菜单
              data = {
                id: localStorage['admin_id']
              };
              console.log("menu data", data);
              url = helper.apiHost + helper.apiUrl.menuList;
              _context.next = 5;
              return axios({
                url: url,
                method: 'post',
                data: data
              });
            case 5:
              res = _context.sent;
              console.log("menu res", res);
              _this3.$store.commit('d2admin/menu/asideSet', res.data.menu);
              _this3.$store.commit('d2admin/menu/roleSet', res.data.role);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    createCode: function createCode() {
      var code = "";
      var codeLength = 4; //验证码的长度
      var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'); //随机数
      for (var i = 0; i < codeLength; i++) {
        //循环操作
        var index = Math.floor(Math.random() * 36); //取得随机数的索引（0~35）
        code += random[index]; //根据索引取得随机数加到code上
      }

      this.checkCode = code; //把code值赋给验证码
    },
    // 点击验证码刷新验证码
    changeCode: function changeCode() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var data, url, res, re;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this4.identifyCode = '';
              // this.makeCode(this.identifyCodes, 4)
              data = {
                // id: localStorage['admin_id']
              }; // console.log("vc data", data);
              url = helper.apiHost + helper.apiUrl.getyzm;
              _context2.next = 5;
              return axios({
                url: url,
                method: 'get'
                // data: data
              });
            case 5:
              res = _context2.sent;
              re = JSON.parse(res);
              _this4.identifyCode = re.value;
              localStorage.setItem("vKey", re.key);
              localStorage.setItem("vValue", re.value);

              //  let k = localStorage.getItem("vKey");
              // let v = localStorage.getItem("vValue");

              //  console.log("key", k);
              //  console.log("value", v);
              // this.$store.commit('d2admin/getyzm/asideSet', res.data.menu)
              // this.$store.commit('d2admin/getyzm/roleSet', res.data.role)
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    } // 生成一个随机整数  randomNum(0, 10) 0 到 10 的随机整数， 包含 0 和 10
    // randomNum (min, max) {
    //   max = max + 1
    //   return Math.floor(Math.random() * (max - min) + min)
    // },
    // // 随机生成验证码字符串
    // makeCode (data, len) {
    //   for (let i = 0; i < len; i++) {
    //     this.identifyCode += data[this.randomNum(0, data.length - 1)]
    //   }
    // }
  })
};